import { Box, CircularProgress, Fade } from '@mui/material';

import { typedStyles } from '@/utils/styleUtils';

const styles = typedStyles({
  common: ({ palette }) => ({
    display: 'grid',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    placeItems: 'center',
    backgroundColor: palette.background.default,
    backgroundImage: palette.custom.backgroundGradient,
    borderRadius: 'inherit',
  }),

  absolute: {
    zIndex: 10,
    position: 'absolute',
  },

  fixed: {
    zIndex: 10e5,
    position: 'fixed',
  },

  /**
   * The grey-to-white wash is for a cover sitting on a card. A full-screen wait uses the
   * portal page color instead, so refresh does not flash a white sheet before the page.
   */
  matchPage: {
    backgroundImage: 'none',
  },
});

export const Loader = ({
  active,
  position = 'fixed',
  matchPage = false,
}: {
  active: boolean;
  position?: 'fixed' | 'absolute';
  matchPage?: boolean;
}) => {
  return (
    <Fade in={active} appear={false} unmountOnExit>
      <Box sx={[styles.common, matchPage && styles.matchPage, styles[position]]}>
        <CircularProgress />
      </Box>
    </Fade>
  );
};
